import { Fragment } from "react";
import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import SigninForm from "./signinForm";
import HeadSection from "../../../components/meta";
// import Partners from "../../../components/partners";
export default function SignIn() {
  return (

   <Fragment>
      <HeadSection
        title={"SIGNIN"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Empower yourself with Seed to Tree—your tech blog & academy for mastering AI, software, and IT. Discover expert tutorials and digital solutions to unlock your potential."
        }
        link={`/signin`}
      />
      <Header isActive="signin" />
      
      <SigninForm />
      {/* <Partners /> */}
      <Footer />
    </Fragment>
  );
}
